import { IconCalendarFilled } from '@tabler/icons-react';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import FieldChipGroup from 'components/shared/form/FieldChipGroup';
import FieldDate from 'components/shared/form/FieldDate';
import FieldSelect from 'components/shared/form/FieldSelect';
import { useCreateMeetingDrawerModal } from 'stores/global/CreateMeetingDrawerModal';
import { getMinDate } from 'utils/getMinDate';

import s from './Detail.module.scss';

const Detail: React.FC = () => {
  const createMeetingDrawerModal = useCreateMeetingDrawerModal();
  const { projectTimeSlot, createLoadingStage, clientUniquenessStore } = createMeetingDrawerModal;

  return (
    <>
      {clientUniquenessStore.shouldCheckUniqueByPhoneOnly && (
        <FieldSelect
          fw="600"
          label="Проект"
          placeholder="Выберите проект"
          store={projectTimeSlot.projects}
          disabled={createLoadingStage.isLoading}
        />
      )}
      <FieldChipGroup
        store={projectTimeSlot.isOffline}
        label="Тип встречи"
        single
        disabled={createLoadingStage.isLoading}
      />
      {projectTimeSlot.slot.shown && (
        <FieldDate
          fw="600"
          fwInput="400"
          label="Дата"
          minDate={getMinDate(new Date())}
          placeholder="Выберите дату"
          valueFormat="DD MMM YYYY"
          store={projectTimeSlot.date}
          icon={<IconCalendarFilled size={24} />}
          disabled={createLoadingStage.isLoading}
        />
      )}
      {projectTimeSlot.slot.projectId.value && (
        <FieldChipGroup
          single
          label="Время"
          groupClassName={cn(
            s.fieldChipGroup__group,
            projectTimeSlot.slot.options.length === 0 && s.fieldChipGroup__group_empty,
          )}
          loaderClassName={s.fieldChipGroup__loader}
          labelClassName={s.fieldChipGroup__label}
          store={projectTimeSlot.slot}
          disabled={createLoadingStage.isLoading}
        />
      )}
    </>
  );
};

export default observer(Detail);
